import React from "react";
import { HeaderContent, HeaderContentArgs } from "../headerContent";
import "./index.scss";

export interface HeaderArgs extends HeaderContentArgs {
  headerImg: string;
}

export const Header = ({ headerImg, ...rest }: HeaderArgs) => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const src = require(`../../../assets/images/${headerImg}`);

  return (
    <div className="header">
      <img src={src.default} alt={headerImg} />
      <HeaderContent {...rest} />
    </div>
  );
};
